import React, { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { useAccessControl } from 'components/common/accessControl/useAccessControl';
import { HorizontalTabNav } from 'components/common/horizontalTabNav';
import { PERMISSIONS } from 'constants/permissions';
import { ADMIN_ROUTES } from 'constants/routes';

export const TabNav = React.memo(() => {
  const { pathname } = useLocation();
  const { hasAccess } = useAccessControl();

  const navigationItems = useMemo(() => {
    const items = [
      {
        path: ADMIN_ROUTES.brand.management,
        label: 'Management',
        permission: PERMISSIONS.brands.tabs.management.read,
        id: '1',
      },
      {
        path: ADMIN_ROUTES.brand.pricingAndSuppliers,
        label: 'Pricing and Suppliers',
        permission: PERMISSIONS.brands.tabs.pricing_and_suppliers.read,
        id: '2',
      },
      {
        path: ADMIN_ROUTES.brand.pricelists,
        label: 'Pricelists',
        permission: PERMISSIONS.brands.tabs.pricelist.read,
        id: '3',
      },
      {
        path: ADMIN_ROUTES.brand.communicationHub,
        label: 'Communication Hub',
        permission: PERMISSIONS.brands.tabs.communicationHub.read,
        id: '4',
      },
      {
        path: ADMIN_ROUTES.brand.tasks,
        label: 'Tasks',
        permission: PERMISSIONS.brands.tabs.task.read,
        id: '5',
      },
      {
        path: ADMIN_ROUTES.brand.attachments,
        label: 'Attachments',
        permission: PERMISSIONS.brands.tabs.attachment.read,
        id: '6',
      },
      {
        path: ADMIN_ROUTES.brand.logs,
        label: 'Logs',
        permission: PERMISSIONS.brands.tabs.logs.read,
        id: '7',
      },
    ];

    return items.filter((i) => hasAccess(i.permission));
  }, [hasAccess]);

  return <HorizontalTabNav pathname={pathname} navigationItems={navigationItems} />;
});
